<template>
  <div class="partner-item">
    <img :src="image" :alt="name" class="partner-item__image" width="125"/>
    <div class="partner-item__content">
      <h3 class="mem-font--project300__partner-name">{{ name }}</h3>
      <p class="mem-font--project300__partner-description">{{ description }}</p>
    </div>
    <a :href="url" target="_blank" class="partner-item__button mem-font--project300__button">
      GO TO SITE
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_560_44)">
          <path d="M0.545131 14C0.154604 13.8747 0.0219727 13.5947 0.0219727 13.1968C0.0219727 9.90316 0.0219727 6.60947 0.0219727 3.31579C0.0219727 2.80737 0.265131 2.56421 0.773552 2.56421C2.82934 2.56421 4.88513 2.56421 6.94092 2.56421C7.2946 2.56421 7.53776 2.73368 7.61881 3.03579C7.72197 3.38947 7.47881 3.76526 7.11776 3.81684C7.03671 3.83158 6.95566 3.83158 6.8746 3.83158C5.07671 3.83158 3.27881 3.83158 1.48829 3.83158C1.42934 3.83158 1.37039 3.83158 1.30408 3.83158V12.7179H10.183C10.183 12.6589 10.183 12.6074 10.183 12.5484C10.183 10.7358 10.183 8.91579 10.183 7.10316C10.183 6.75684 10.323 6.52105 10.5957 6.41789C10.9788 6.27052 11.3914 6.52105 11.4504 6.93368C11.4578 7 11.4578 7.06631 11.4578 7.14C11.4578 9.15895 11.4578 11.1779 11.4578 13.1968C11.4578 13.5947 11.3325 13.8747 10.9346 14H0.545131Z" fill="black"/>
          <path d="M13.9999 5.86517C13.9483 5.9536 13.9188 6.05675 13.8525 6.13781C13.6978 6.34412 13.4251 6.41781 13.182 6.34412C12.9388 6.27044 12.7694 6.06412 12.7399 5.80623C12.7325 5.73254 12.7325 5.65886 12.7325 5.58517C12.7325 4.51675 12.7325 3.44833 12.7325 2.37991V2.1957C12.6736 2.25465 12.6367 2.29149 12.5999 2.32096C10.4925 4.42833 8.37778 6.54307 6.27041 8.65044C6.07883 8.84202 5.87252 8.95254 5.59989 8.88623C5.15041 8.78307 4.9662 8.24517 5.25357 7.88412C5.29778 7.82517 5.34936 7.77359 5.40094 7.72202C7.49357 5.62202 9.59357 3.52939 11.6936 1.42939C11.7304 1.39254 11.782 1.36307 11.8262 1.3336C11.8188 1.31886 11.8115 1.29675 11.8041 1.28202C11.7525 1.28202 11.7009 1.28202 11.6494 1.28202C10.5662 1.28202 9.48304 1.28202 8.39989 1.28202C8.27462 1.28202 8.14199 1.26728 8.03147 1.2157C7.7662 1.10517 7.6262 0.825175 7.67041 0.537806C7.72199 0.257806 7.95041 0.0441221 8.23778 0.0146484C8.28936 0.0146484 8.34831 0.0146484 8.39989 0.0146484C9.99883 0.0146484 11.5978 0.0146484 13.2041 0.0146484C13.602 0.0146484 13.882 0.139912 14.0073 0.537806V5.85781L13.9999 5.86517Z" fill="black"/>
        </g>
        <defs>
          <clipPath id="clip0_560_44">
            <rect width="14" height="14" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </a>
  </div>
</template>

<script>
export default {
  name: 'PartnerItem',
  props: {
    name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  methods: {
    makeUrl(image) {
      return new URL(image).href
    }
  }
  
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px;
  background-color: #121212;
  border-radius: 8px;
  margin-bottom: 24px;
  gap: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  @media screen and (min-width: #{$tablet + 1px}) {
    flex-direction: row;
    align-items: center;
  }
}

.partner-item__image {
  flex-shrink: 0;
}

.partner-item__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .mem-font--project300__partner-description {
    margin-bottom: 16px;
    @media screen and (min-width: #{$tablet + 1px}) {
      margin-bottom: 0;
    }
  }
  
  @media screen and (min-width: #{$tablet + 1px}) {
    margin-left: 16px;
    margin-right: 32px;
  }
}

.partner-item__button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 44px;
  padding: 0 24px;
  background-color: #FFFFFF;
  color: #000000;
  border: none;
  border-radius: 22px;
  cursor: pointer;
  text-decoration: none;
  width: 100%;
  
  @media screen and (min-width: #{$tablet + 1px}) {
    width: auto;
  }
  
  svg {
    flex-shrink: 0;
  }
}
</style>